// src/routes.js
import React from 'react'
import AlertContainer from 'react-alert'

const CustomAlert = ({ position = 'top right',
  theme = 'dark',
  time = 3000,
  transition = 'fade',
  reference }) => (
  <AlertContainer
    ref={reference}
    position={position}
    theme={theme}
    time={time}
    transition={transition}
  />
)

export default CustomAlert



// WEBPACK FOOTER //
// ./src/components/common/CustomAlert/CustomAlert.js